export const onetrustShowSettings = (event) => {
  event?.stopImmediatePropagation ? event?.stopImmediatePropagation() : event.nativeEvent.stopImmediatePropagation();
  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  }
}

export const initCookiePolicy = () => {
  const sec = document.getElementById("ot-sdk-cookie-policy");
  if (sec && window.OneTrust) {
    console.log('initCookiePolicy exec');
    try {
      window.OneTrust.initializeCookiePolicyHtml();
    } catch (err) {
      console.error('initCookiePolicy err: ', err);
    }
  }
  // Aggiunge il listener al pulsante "Personalizza" cookie
  setTimeout(() => {
    const toggleDisplay = document.getElementsByClassName("ot-sdk-show-settings");
    for (let i = 0; i < toggleDisplay.length; i++) {
      toggleDisplay[i].onclick = onetrustShowSettings;
    }
  }, 1000);
}

export const initOnetrustBanner = () => {
  try {
    if (typeof document !== "undefined") {
      let onetrustGroupGontainer = document.getElementById("onetrust-group-container");
      let onetrustButtonGroupParent = document.getElementById("onetrust-button-group-parent");
      let onetrustCloseBtnContainer = document.getElementById("onetrust-close-btn-container");
      let onetrustBannerSdk = document.getElementById("onetrust-banner-sdk");
      let onetrustPcBtnHandler = document.getElementById("onetrust-pc-btn-handler");
      let onetrustAcceptBtnHandler = document.getElementById("onetrust-accept-btn-handler");
      let onetrustButtonGroup = document.getElementById("onetrust-button-group");

      if (
        onetrustGroupGontainer &&
        onetrustButtonGroupParent &&
        onetrustCloseBtnContainer &&
        onetrustBannerSdk &&
        onetrustPcBtnHandler &&
        onetrustAcceptBtnHandler &&
        onetrustButtonGroup
      ) {
        onetrustGroupGontainer.className = "ot-sdk-nine ot-sdk-columns";

        while (onetrustButtonGroup.firstChild) {
          onetrustButtonGroup.removeChild(onetrustButtonGroup.firstChild);
        }

        while (onetrustBannerSdk.firstChild) {
          onetrustBannerSdk.removeChild(onetrustBannerSdk.firstChild);
        }

        let otSdkContainer = document.createElement("div");
        otSdkContainer.className = "ot-sdk-container";
        let otSdkRow = document.createElement("div");
        otSdkRow.className = "ot-sdk-row";

        let divLogo = document.createElement("div");
        divLogo.className = "ot-sdk-three ot-sdk-columns";
        let logo =
          '<div class="header__logo text-center" style="padding: 1em;"><img src="data:image/svg+xml;base64,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" class="h-100" alt="Engie Casa" style="width: 50%;"></div>';
        divLogo.innerHTML = logo;

        otSdkRow.appendChild(divLogo);
        otSdkRow.appendChild(onetrustGroupGontainer);

        onetrustButtonGroup.appendChild(onetrustPcBtnHandler);
        onetrustButtonGroup.appendChild(onetrustAcceptBtnHandler);

        otSdkRow.appendChild(onetrustButtonGroupParent);
        otSdkRow.appendChild(onetrustCloseBtnContainer);
        otSdkContainer.appendChild(otSdkRow);
        onetrustBannerSdk.appendChild(otSdkContainer);
      }

      let onetrustConsentSdk = document.getElementById("onetrust-consent-sdk");
      if (onetrustConsentSdk) {
        let onetrustConsentSdkStyle = document.getElementById("onetrust-consent-sdk").style;
        onetrustConsentSdkStyle.display = "block";
      }
    }
  } catch (error) {
    console.error(error);
  }
};